import { useEffect } from "react";
import Lenis from "lenis";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Marquee from "@/components/Marquee";
import Projects from "@/components/Projects";
import WhyChoose from "@/components/WhyChoose";
import QuoteBand from "@/components/QuoteBand";
import Bookings from "@/components/Bookings";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);

    const handleClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const targetId = anchor.getAttribute("href");
      if (targetId === "#" || targetId.length < 2) return;
      const el = document.querySelector(targetId);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", handleClick);

    return () => {
      cancelAnimationFrame(id);
      document.removeEventListener("click", handleClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain" data-testid="home-root">
      <Navbar />
      <main>
        <Hero />
        <Manifesto />
        <Services />
        <Marquee />
        <Projects />
        <WhyChoose />
        <QuoteBand />
        <Bookings />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
